import type { VisitChecklist } from '../types/index.ts';
import type { ChecklistDefinition } from './stack.ts';

/**
 * A visit's snapshotted checklist as an editable definition, grouped back
 * into its sections in order. The office's "edit this visit's checklist"
 * form starts from this, and so does adding a saved add-on's task to one
 * visit (migration 0093), so both rewrite the visit the same way.
 */
export function definitionFromVisit(checklist: VisitChecklist, name: string): ChecklistDefinition {
  const sections: ChecklistDefinition['sections'] = [];
  let previousKey: string | undefined;
  for (const item of checklist.items) {
    const key = item.sectionKey ?? item.areaName;
    let section = sections.at(-1);
    if (!section || key !== previousKey) {
      section = {
        id: crypto.randomUUID(),
        name: item.areaName,
        nameTranslations: item.areaNameTranslations,
        rule: item.sectionRule ?? { weekdays: [], everyNthVisit: null, frequency: 'every_visit' },
        tasks: [],
      };
      sections.push(section);
      previousKey = key;
    }
    section.tasks.push({
      id: item.id,
      name: item.taskName,
      nameTranslations: item.taskNameTranslations,
      description: item.description,
      descriptionTranslations: item.descriptionTranslations,
      estimatedMinutes: item.estimatedMinutes ?? 0,
      requiresPhoto: item.requiresPhoto,
      rule: item.taskRule ?? { weekdays: [], everyNthVisit: null, frequency: item.frequency },
    });
  }
  return { name, nameTranslations: null, kind: 'custom', sections };
}
